/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface HtmlPageConfigInfoRespVo
 */
export interface HtmlPageConfigInfoRespVo {
    /**
     * 数据编号
     * @type {number}
     * @memberof HtmlPageConfigInfoRespVo
     */
    id?: number;
    /**
     * 页面名称
     * @type {string}
     * @memberof HtmlPageConfigInfoRespVo
     */
    pageName?: string;
    /**
     * 内容（韩文）
     * @type {string}
     * @memberof HtmlPageConfigInfoRespVo
     */
    content?: string;
    /**
     * 内容（中文）
     * @type {string}
     * @memberof HtmlPageConfigInfoRespVo
     */
    contentCn?: string;
    /**
     * 排序
     * @type {number}
     * @memberof HtmlPageConfigInfoRespVo
     */
    sort?: number;
    /**
     * 是否可用：0-不可用，1-可用
     * @type {number}
     * @memberof HtmlPageConfigInfoRespVo
     */
    enable?: number;
    /**
     * 页面区域类型：1-服务条款，2-个人信息搜集和使用信息，3-页面底部公司信息，4-客服联系信息，5-下单须知
     * @type {number}
     * @memberof HtmlPageConfigInfoRespVo
     */
    pageType?: number;
    /**
     * 适用订单类型列表，仅下单须知页面使用
     * @type {Array<number>}
     * @memberof HtmlPageConfigInfoRespVo
     */
    orderType?: Array<number>;
    /**
     * 是否可删除；仅下单须知可删除
     * @type {boolean}
     * @memberof HtmlPageConfigInfoRespVo
     */
    deletable?: boolean;
    /**
     * 是否可修改页面类型；仅下单须知可改
     * @type {boolean}
     * @memberof HtmlPageConfigInfoRespVo
     */
    pageTypeEditable?: boolean;
    /**
     * 是否可停用；仅下单须知可停用
     * @type {boolean}
     * @memberof HtmlPageConfigInfoRespVo
     */
    enableEditable?: boolean;
    /**
     * 创建时间
     * @type {string}
     * @memberof HtmlPageConfigInfoRespVo
     */
    createTime?: string;
    /**
     * 修改时间
     * @type {string}
     * @memberof HtmlPageConfigInfoRespVo
     */
    updateTime?: string;
}

/**
 * Check if a given object implements the HtmlPageConfigInfoRespVo interface.
 */
export function instanceOfHtmlPageConfigInfoRespVo(value: object): value is HtmlPageConfigInfoRespVo {
    return true;
}

export function HtmlPageConfigInfoRespVoFromJSON(json: any): HtmlPageConfigInfoRespVo {
    return HtmlPageConfigInfoRespVoFromJSONTyped(json, false);
}

export function HtmlPageConfigInfoRespVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): HtmlPageConfigInfoRespVo {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'pageName': json['pageName'] == null ? undefined : json['pageName'],
        'content': json['content'] == null ? undefined : json['content'],
        'contentCn': json['contentCn'] == null ? undefined : json['contentCn'],
        'sort': json['sort'] == null ? undefined : json['sort'],
        'enable': json['enable'] == null ? undefined : json['enable'],
        'pageType': json['pageType'] == null ? undefined : json['pageType'],
        'orderType': json['orderType'] == null ? undefined : json['orderType'],
        'deletable': json['deletable'] == null ? undefined : json['deletable'],
        'pageTypeEditable': json['pageTypeEditable'] == null ? undefined : json['pageTypeEditable'],
        'enableEditable': json['enableEditable'] == null ? undefined : json['enableEditable'],
        'createTime': json['createTime'] == null ? undefined : json['createTime'],
        'updateTime': json['updateTime'] == null ? undefined : json['updateTime'],
    };
}

export function HtmlPageConfigInfoRespVoToJSON(json: any): HtmlPageConfigInfoRespVo {
    return HtmlPageConfigInfoRespVoToJSONTyped(json, false);
}

export function HtmlPageConfigInfoRespVoToJSONTyped(value?: HtmlPageConfigInfoRespVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'pageName': value['pageName'],
        'content': value['content'],
        'contentCn': value['contentCn'],
        'sort': value['sort'],
        'enable': value['enable'],
        'pageType': value['pageType'],
        'orderType': value['orderType'],
        'deletable': value['deletable'],
        'pageTypeEditable': value['pageTypeEditable'],
        'enableEditable': value['enableEditable'],
        'createTime': value['createTime'],
        'updateTime': value['updateTime'],
    };
}

